import Image from 'next/image'
import Link from 'next/link'
import cl from 'classnames'

type Props = {
  className?: string
}

export const MenuContentOMUsinasSolares = ({ className }: Props) => {
  return (
    <div
      className={cl(
        'relative w-full h-60 rounded-2xl overflow-hidden',
        className
      )}
    >
      <Image
        src="/assets/new/portal-solar-om-cursos-01.webp"
        alt="Maior plataforma de O&M de Usinas de Energia Solar"
        fill
        quality={100}
        className="object-cover object-right"
      />

      <div className="absolute left-10 top-14 flex flex-col gap-7">
        <p className="w-[640px] h-[72px] text-[40px] leading-[44px] tracking-[0.8px] font-light text-white">
          A maior plataforma de O&M
          <br />
          de Usinas de Energia Solar
        </p>
        <Link
          href="https://pvoperation.com"
          rel="nofollow"
          target="_blank"
          className="w-fit h-10 flex items-center justify-center bg-gradient-to-r from-v3-orange-350 to-v3-orange-500 hover:brightness-105 text-base leading-4 tracking-[1.2px] font-semibold uppercase rounded-full px-6 transition duration-300"
        >
          SAIBA MAIS
        </Link>
      </div>
    </div>
  )
}
